import { Env } from '@didi/utils'
// import { mqqReady } from '../core/mqq'
import { alipayReady } from '../core/alipay'
import { didiSDKReady } from '../core/didi'
import { noop, getContent } from '../util/tool'
import commonLangZh from '../lang/zh-CN/common'
import commonLangEn from '../lang/en-US/common'

const allContent = {
  'zh-CN': {
    ...commonLangZh
  },
  'en-US': {
    ...commonLangEn
  }
}
let lang

export function setPageTitle (conf, callback = noop) {
   /* istanbul ignore else */
  if (conf && conf.lang) {
    lang = conf.lang
  }
  if (Env.isWechat) {
    wechatTitle(conf, callback)
  } else if (Env.isAlipay) {
    alipayTitle(conf, callback)
  } else if (Env.isMqq) {
    mqqTitle(conf, callback)
  } else if (Env.isPassenger) {
    passengerTitle(conf, callback)
  } else {
    h5Title(conf, callback)
  }
}
export default setPageTitle

function wechatTitle(conf, callback) {
  document.title = conf.title
  iframeTitle(conf.title, callback)
}

function alipayTitle(conf, callback) {
  alipayReady((err, alipay) => {
     /* istanbul ignore else */
    if (err) {
      callback(err)
      return
    }
     /* istanbul ignore else */
    if (!alipay) {
      callback(new Error(getContent(allContent, 'alipayBridgeError', lang)))
      return
    }
    alipay.call('setTitle', conf)
    callback(null, true)
  })
}

function mqqTitle(conf, callback) {
  document.title = conf.title
   /* istanbul ignore else */
  if (!Env.isIOS) {
    return
  }
  iframeTitle(conf.title, callback)
  // todo mqq refreshTitle 最新版本无效，先用iframe方式代替
  // mqqReady((err, mqq) => {
  //    /* istanbul ignore else */
  //   if (err) {
  //     callback(err)
  //     return
  //   }
  //    /* istanbul ignore else */
  //   if (!mqq) {
  //     callback(new Error(getContent(allContent, 'mqqBridgeError', lang)))
  //     return
  //   }
  //   mqq.invoke('ui', 'refreshTitle')
  //   callback(null, true)
  // })
}
function passengerTitle(conf, callback) {
  didiSDKReady((err, bridge) => {
    if (!err) {
      bridge.call('setTitle', {
        title: conf.title
      }, (err, ret) => {
        callback(err, ret)
      })
    }
  })
}
function h5Title(conf, callback) {
  document.title = conf.title
  callback(null, true)
}

function iframeTitle(title, callback) {
  const iframe = document.createElement('iframe')
  iframe.style.visibility = 'hidden'
  iframe.style.display = 'none'
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.border = 'none'
  iframe.src = '/favicon.ico'
  iframe.onload = () => {
    setTimeout(() => {
      document.body.removeChild(iframe)
      callback(null, true)
    }, 0)
  }
  document.body.appendChild(iframe)
}
